// extracted by mini-css-extract-plugin
export default {"info":"styles_info__MstVd","middle":"styles_middle__Ebofj","right":"styles_right__hIhye"};